import { render, staticRenderFns } from "./seminar_content.vue?vue&type=template&id=b0acbbce"
import script from "./seminar_content.vue?vue&type=script&lang=js"
export * from "./seminar_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports